import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'unos-izmjena-plice',
	templateUrl: './unos-izmjena-plice.component.html',
	styleUrls: ['./unos-izmjena-plice.component.css']
})
export class UnosIzmjenaPravnoLice implements OnInit {
	@Input() id;
	@Input() nazivPLice;

	@Output() onInsertPLice = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	daneStavke : any = [{ 'id': '0', 'naziv': 'Ne', jeOdabran: false }, { 'id': '1', 'naziv': 'Da', jeOdabran: false }];
	plice : any = {id : null, pib : null, naziv : null, adresa : null};

	err_naziv = false;
	err_naziv_poruka = '';

	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;

	ucitaj() {
		if (!this.id)
			return;

		this.loading = true;
		this.http.get('vlasnici/detaljno', { params: { id: this.id } })
			.subscribe(data => {
				this.loading = false;
				this.plice = data;

				setTimeout(() => {
					M.updateTextFields();
				}, 300);
				
				//this.ucitajSkole();
			}
			, error => {
				this.loading = false;
			});
	}

	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		if (!this.plice.naziv) {
			this.err_naziv = true;
			this.err_naziv_poruka = 'Morate definisati polje Naziv.';
			M.toast({html: this.err_naziv_poruka, displayLength : this.toastTimeout});
			return;
		}

		let url = 'vlasnici/pravno/dodaj';
		if (this.id){
			url = 'vlasnici/pravno/izmijeni';
		}

		this.loading = true;
		
		setTimeout(() => {				
		
			this.http.post(url, this.plice)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (!this.id) {
							this.plice.id = this.msg.newId;
						}
						if (this.onInsertPLice)
							this.onInsertPLice.emit(this.plice);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

}
